import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TUserMgmtConnectedEmerchantsStore } from './types';

export const getUserMgmtConnectedEmerchantsState = (
	state: TStoreState,
): TUserMgmtConnectedEmerchantsStore => state.userMgmtConnectedEmerchants;

export const selectUserMgmtConnectedEmerchants = createSelector(
	[getUserMgmtConnectedEmerchantsState],
	(state: TUserMgmtConnectedEmerchantsStore) => state.connectedEmerchants,
);

export const selectUserMgmtConnectedEmerchantsLoading = createSelector(
	[getUserMgmtConnectedEmerchantsState],
	(state: TUserMgmtConnectedEmerchantsStore) => state.connectedEmerchantsLoading,
);

export const selectUserMgmtConnectedEmerchantsFailure = createSelector(
	[getUserMgmtConnectedEmerchantsState],
	(state: TUserMgmtConnectedEmerchantsStore) => state.connectedEmerchantsFailure,
);
